import React, { useState } from 'react';
import { Form, Button, Drawer, Grid } from 'antd';
import { FilterOutlined } from '@ant-design/icons';

const { useBreakpoint } = Grid;

const ResponsiveFilterContainer = ({
  form,
  children,
  onSearch,
  onReset,
  extraButtons,
  ...restProps
}) => {
  const [open, setOpen] = useState(false);
  const screens = useBreakpoint();

  const isMobile = !screens.sm; // < 'sm' (576px)

  const mobileDrawer = (
    <Drawer
      title="Filter"
      placement="right"
      onClose={() => setOpen(false)}
      open={open}
      forceRender={true} //in case parent call form
      width="85%"
      footer={
        <div className="flex justify-end gap-3">
          <Button
            onClick={() => {
              onReset();
              setOpen(false);
            }}
          >
            Reset
          </Button>
          <Button
            type="primary"
            onClick={() => {
              const values = form.getFieldsValue();
              onSearch(values);
              setOpen(false);
            }}
          >
            Search
          </Button>
        </div>
      }
    >
      <Form form={form} layout="vertical" component={false} {...restProps}>
        {children}
      </Form>
    </Drawer>
  );

  if (isMobile) {
    return (
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '8px',
          alignItems: 'center',
          flex: 1,
        }}
      >
        {extraButtons}
        <Button
          type="primary"
          icon={<FilterOutlined />}
          onClick={() => setOpen(true)}
        >
          Filter
        </Button>
        {mobileDrawer}
      </div>
    );
  }

  const gap = 10; // px

  // items * itemWidth + totalGapWidth = 100%
  const itemWidth = screens.lg
    ? `calc(25% - ${(gap * 3) / 4}px)` // 4 items even 3 gaps
    : `calc(50% - ${gap / 2}px)`; // 2 items even 1 gap

  return (
    <div className="bg-white p-6 mb-6 rounded-lg shadow-sm">
      <Form
        form={form}
        onFinish={onSearch}
        layout="horizontal"
        style={{ width: '100%' }}
        {...restProps}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: `${gap}px`,
            width: '100%',
          }}
        >
          {React.Children.map(children, (child) => {
            if (!child) return null;

            // check Fragment (<>...</> or <React.Fragment>) to get its children
            if (child.type === React.Fragment) {
              return React.Children.map(
                child.props.children,
                (fragmentChild) => {
                  if (!fragmentChild) return null;
                  return (
                    <div style={{ width: itemWidth }}>{fragmentChild}</div>
                  );
                }
              );
            }

            return <div style={{ width: itemWidth }}>{child}</div>;
          })}

          <div
            style={{
              flexGrow: 1,
              display: 'flex',
              gap: '8px',
            }}
          >
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button onClick={onReset}>Reset</Button>
            {extraButtons}
          </div>
        </div>
      </Form>
    </div>
  );
};

export default ResponsiveFilterContainer;
